<template>
  <div v-if="filteredAmenities.length" class="amenities-wrapper">
    <Text variant="body-large" v-for="amenity in filteredAmenities" :key="amenity">
      {{ amenity }}
    </Text>
  </div>

  <p v-else>No amenities</p>

  <Button
    variant="ghost"
    size="small"
    class="show-amenities-button"
    v-if="amenitiesList.length > maxVisibleAmenities"
    @click="showAll = !showAll"
  >
    {{ showAll ? 'See Less ↑' : 'See More ↓' }}
  </Button>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

import { Button, Text } from '@tallo/design-system';

import { AmenitiesDto, amenityNamesMap } from '../../model/amenities';
import { PropertyDto } from '../../model/property';

const props = defineProps<{
  property: PropertyDto | null | undefined;
}>();

const maxVisibleAmenities = 6;
const showAll = ref(false);

const amenitiesList = computed(() => {
  return Object.entries(props.property?.amenities || {})
    .filter(([key, value]) => value && key in amenityNamesMap)
    .map(([key]) => amenityNamesMap[key as keyof Omit<AmenitiesDto, 'id'>] || key)
    .sort();
});

const filteredAmenities = computed(() => {
  return showAll.value ? amenitiesList.value : amenitiesList.value.slice(0, maxVisibleAmenities);
});
</script>

<style scoped lang="scss">
.amenities-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: var(--t-spacing-sm);
}

.show-amenities-button {
  margin-top: 0.645rem;
}
</style>
